import { ValidatorFn, ValidationErrors, AbstractControl } from '@angular/forms';

export function maxAgeValidator(maxAge: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const birthday = new Date(control.value);
    const currentAge = getCurrentAge(birthday);

    return !control.value || currentAge < maxAge ? null : { ageInvalid: true };
  };
}

export function minAgeValidator(minAge: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const birthday = new Date(control.value);
    const currentAge = getCurrentAge(birthday);

    return !control.value || currentAge >= minAge ? null : { minAgeInvalid: true };
  };
}

export interface AgeLimits {
  upperAgeLimit?: number | null;
  lowerAgeLimit?: number | null;
}

export interface AgeLimitStatus {
  exceedsUpperAgeLimit: boolean;
  isBelowLowerAgeLimit: boolean;
}

export const getAgeLimitStatus = (
  birthday: Date | string | null | undefined,
  limits: AgeLimits | null | undefined
): AgeLimitStatus => {
  if (!birthday || !limits) {
    return { exceedsUpperAgeLimit: false, isBelowLowerAgeLimit: false };
  }

  const currentAge = getCurrentAge(new Date(birthday));
  const { upperAgeLimit, lowerAgeLimit } = limits;

  return {
    exceedsUpperAgeLimit: !!upperAgeLimit && currentAge >= upperAgeLimit,
    isBelowLowerAgeLimit: !!lowerAgeLimit && currentAge < lowerAgeLimit,
  };
};

export const getCurrentAge = (birthday: Date): number => {
  const birthDate = new Date(birthday);
  const today = new Date();

  let age = today.getFullYear() - birthDate.getFullYear();

  const isBirthdayPassedThisYear =
    today.getMonth() > birthDate.getMonth() ||
    (today.getMonth() === birthDate.getMonth() && today.getDate() >= birthDate.getDate());

  if (!isBirthdayPassedThisYear) {
    age--;
  }

  return age;
};
